
export class FotografiaProductoId {
    idFotografia: number;
    codigoProductoPresentacion: number;
    codigoProducto: number;
    codigoPresentacion: number;
    codigoMarca: number;
}